import moment from 'moment';

import { FORM_HISTORY_STATUSES } from '../form-designer/constants/editor.constants';
import { xml2json } from '../form-designer/utils/runtime.utils';

export const modifyForms = (forms = []) =>
  forms.map((form) => ({
    id: form.OPS_ID,
    name: form.OPS_NAME,
    formKey: form.OPS_KEY,
    entityType: form.OPS_PARENT_KEY,
    description: form.OPS_DESCRIPTION,
    status: FORM_HISTORY_STATUSES[form.OPS_PUBLISHED] ?? '',
    version: form.OPS_VERSION,
    modifiedDate: (form.OPS_MODIFIED_DATE && moment.utc(form.OPS_MODIFIED_DATE).local()) || '',
    releaseVersion: form.OPS_RELEASE_VERSION,
    releaseType: form.OPS_RELEASE_TYPE,
  }));

export const validateFormXml = ({ xml, errorMessage }) => {
  const parsedJson = xml2json(xml);
  const { formDesign, ssFormInfo } = parsedJson?.formPackage ?? {};

  if (!formDesign || !ssFormInfo) {
    throw new Error(errorMessage);
  }
};
